export default __webpack_public_path__ + "static/gitkraken_gitdiff-ca29594211e0df958ddb514e9925b9e3.png";